if ($('[data-component="ftue-container"]').length) {
    (function () {
        $(window).bind("load", function () {
            var direction = document.dir || document.getElementsByTagName('html')[0].getAttribute('dir');
            var delayTimer;

            clearTimeout(delayTimer);

            delayTimer = setTimeout(function () {
                modalShowId('#ftue-modal');
                $('#ftue-modal .modal-content').focus();
            }, 3000);
            populateFTUE();
            
        });

        var $carouselContainer = $("#ftue-container");
        var itemCount = $carouselContainer.data('item-count');

        function populateFTUE() {
            var ctaNext = $carouselContainer.data('cta-next');
            var is_IE = false || !!document.documentMode;
            setTimeout(function () {

                $carouselContainer.slick({
                    dots: false,
                    arrows: true,
                    infinite: false,
                    swipe: true,
                    touchMove: false,
                    speed: 300,
                    slidesToShow: 1,
                    slidesToScroll: 1,

                    prevArrow: '<button type="button" data-role="none" class="slick-prev slick-arrow" aria-label="Previous" style="display: none;">Previous</button>',
                    nextArrow: $(".slick-next"),

                    responsive: [{
                        breakpoint: 3600,
                        settings: {
                            slidesToShow: 1,
                            slidesToScroll: 1,
                            infinite: false,
                            dots: false,
                            touchMove: false,
                            swipe: true
                        }
                    },
                        {
                            breakpoint: 1024,
                            settings: {
                                slidesToShow: 1,
                                slidesToScroll: 1,
                                infinite: false,
                                dots: false,
                                touchMove: false,
                                swipe: true
                            }
                        },
                                {
                                    breakpoint: 992,
                                    settings: {
                                        slidesToShow: 1,
                                        slidesToScroll: 1,
                                        dots: false,
                                        swipe: true,
                                        touchMove: false,
                                    }
                                },
                            {
                                breakpoint: 768,
                                settings: {
                                    slidesToShow: 1,
                                    slidesToScroll: 1,
                                    dots: false,
                                    swipe: true,
                                    touchMove: true,
                                }

                            }
                    ]
                });

                $('.ftue-header[data-id=0]').show();
          
                if (is_IE) {
                    $('#ftue-modal .bottom-buttons .slick-next').addClass('is-ie');
                }
                $('#ftue-container .slick-track').removeAttr("role");
            }, 1000);
           
        }

        $('#ftue-container').on('afterChange', function (event, slick, currentSlide) {
            $('.ftue-header').hide();
            $('.ftue-header[data-id=' + currentSlide + ']').show();
            $('.ftue-header[data-id=' + currentSlide + ']').focus();
            $('.background-img.ftue-refresh-image').css('display', 'none');
            $('#ftue-container .slick-track').removeAttr("role");
                     
            var sliderContent = $('.slick-slide[data-slick-index=' + currentSlide + '] .ftue-slider-content');
            if (sliderContent.data('has-refresh-image') === 'True') {
                if ($(window).width() >= 768) { // To show desktop image in iPad set breakpoint as 768
                    var desktopImg = $('.slick-slide[data-slick-index=' + currentSlide + '] .background-img.background-img-desktop');
                    refreshImage(desktopImg);
                    $('.background-img-desktop.ftue-refresh-image').nextAll('.ftue-heading').removeAttr('tabindex');
                    $('.background-img-desktop.ftue-refresh-image').nextAll('.ftue-subcopy').removeAttr('tabindex');
                    
                } else {
                    var mobileImg = $('.slick-slide[data-slick-index=' + currentSlide + '] .background-img.background-img-mobile');
                    refreshImage(mobileImg);
                }
            }

            if (currentSlide === itemCount - 1) {
                // Hide last item footer
                $('.bottom-buttons div').attr('style', 'display: none !important');
                $('.slick-next').attr('style', 'display: none !important');
                    $('#ftue-modal .ftue-slider-content .background-img').css('height', '440px');
                    $('#ftue-modal .slick-list').css('height', '440px');
                    $('#ftue-modal .slick-track').css('height', '440px');         
                $('.bottom-buttons').attr('style', 'display: none');
            } else {
                $('.bottom-buttons div').attr('style', 'display: block !important');
                $('.slick-next').attr('style', 'display: block !important');
                    $('#ftue-modal .ftue-slider-content .background-img').css('height', '390px');
                    $('#ftue-modal .slick-list').css('height', '390px');
                    $('#ftue-modal .slick-track').css('height', '390px');            
                $('.bottom-buttons').attr('style', 'display: block');
            }
        });

        function refreshImage(imgDivObj) {
            var img = imgDivObj.find('img');
            var imgSrc = img.attr('src');
            imgSrc = imgSrc + (imgSrc.indexOf('?') > -1 ? '&rnd=' : '?rnd=') + crypto.getRandomValues(new Uint32Array(1))[0]
            ;
            imgDivObj.css('display', 'block');
            img.removeAttr('src');
            img.attr('src', imgSrc);
        }

        $("#skip-button").keydown(function (e) {
            var code = e.keyCode || e.which;
            if (code === 13) { // enter key detected
                modalClose(true);
            }
        });

        $(document).on('keydown', function (e) {
            if (e.keyCode == 37) {
                $carouselContainer.slick('slickPrev');
            }
            if (e.keyCode == 39) {
                $carouselContainer.slick('slickNext');
            }
        });

        $('#ftue-container img, #next-button').on('click', function (e) {
            $('#ftue-container').slick('slickNext')
        });

    })();
}